/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProviderSummary } from './resourceProviderSummary';
import { ResourceProvider } from './resourceProvider';
import { ResourceProviderCategorySummary } from './resourceProviderCategorySummary';


export interface ResourceSummary { 
    categories?: Array<ResourceProviderCategorySummary>;
    provider?: ResourceProvider;
    summary?: ResourceProviderSummary;
}
export namespace ResourceSummary {
}


